<!--
  Save uses POST saveJsonObject?action_code=kzksix — body fields are built in
  lock-unlock.component.ts (submission_id, lock_unlock, tax_year, scenario,
  jcd_key, sso_id, issue_id, issue_short_desc, checkLockedbj, scenarioCode,
  is_issue_key_enabled).
-->
<div class="centered">
  <button
    type="button"
    class="lock-unlock"
    [disabled]="saving"
    [attr.aria-busy]="saving"
    [attr.aria-label]="is_locked ? 'Unlock submission' : 'Lock submission'"
    (click)="lockUnlock()">
    @if (saving) {
<span class="spin-ring" aria-hidden="true"></span>
}
    <i class="fa" [ngClass]="{'fa-lock': is_locked, 'fa-unlock-alt': !is_locked}" aria-hidden="true"></i>
  </button>
  <h2>The submission is currently {{is_locked ? 'Locked' : 'Unlocked'}}. Please click above to {{is_locked ? 'unlock' : 'lock'}}.</h2>
</div>